export class BroadcastMessageEvent {
    public static patchUploadCancel ="PatchUploadCancel";
    public static patchProgressUpdates ="PatchProgressUpdates";
    public static patchProgressUpdateWithDelay ="PatchProgressUpdateWithDelay";
    public static suaKeyUpdates ="SuaKeyUpdates";
    public static remoteSessionUpdates = "RemoteSessionUpdates";
    public static remoteCameraUpdates = "RemoteCameraUpdates";
    public static fileImportUpdates = "FileImportUpdates";
    public static networkOutage = "NetworkOutage";
    public static patchDeploymentDialogUserAction = "patchDeploymentDialogUserAction";
    public static patchDeploymentUpdates = "patchDeploymentUpdates";
}
